import React, { Dispatch } from "react";
import { ActionType } from "./types";
import { GetHomebuyerDto } from "../../services/Homebuyer/dto/get.dto";
import { UpdateStatusParams } from "./usecase.d";

export type HomebuyerStateType = {
  data: Array<GetHomebuyerDto>;
};

export type HomebuyerActionType = {
  type: symbol;
  items?: GetHomebuyerDto[];
  addedItem?: GetHomebuyerDto;
  updatedItem?: GetHomebuyerDto;
  updatedStatusItem?: UpdateStatusParams;
  deletedId?: string;
};

type HomebuyerHomebuyerType = React.Reducer<
  HomebuyerStateType,
  HomebuyerActionType
>;

export type HomebuyerDispatch = Dispatch<HomebuyerActionType>;

const initialGetState: HomebuyerStateType = {
  data: new Array<GetHomebuyerDto>(),
};

interface TransformUpdateDataParams {
  originalData: Array<GetHomebuyerDto>;
  updatedData: GetHomebuyerDto;
}

function transformUpdateData({
  originalData,
  updatedData,
}: TransformUpdateDataParams) {
  return originalData.map((item) => {
    if (item.id === updatedData.id) {
      return updatedData;
    }
    return item;
  });
}

interface TransformUpdateStatusParams {
  originalData: Array<GetHomebuyerDto>;
  updatedData: UpdateStatusParams;
}

function transformUpdateStatusData({
  originalData,
  updatedData,
}: TransformUpdateStatusParams) {
  return originalData.map((item) => {
    const newItem = { ...item };
    if (item.id === updatedData.id) {
      newItem.isActive = updatedData.isActive;
      return newItem;
    }
    return newItem;
  });
}

interface TransformDeleteDataParams {
  originalData: Array<GetHomebuyerDto>;
  deletedId: string;
}

function transformDeleteData({
  originalData,
  deletedId,
}: TransformDeleteDataParams) {
  return originalData.filter((item) => item.id !== deletedId);
}

export const Reducer: HomebuyerHomebuyerType = (
  state = initialGetState,
  action,
) => {
  switch (action.type) {
    case ActionType.GetList:
      return {
        data: action.items || [],
      };
    case ActionType.Create:
      if (!action.addedItem) {
        throw new Error("Added item does not exists");
      }
      return {
        data: [...state.data, action.addedItem],
      };
    case ActionType.Update:
      if (!action.updatedItem) {
        throw new Error("Updated item does not exists");
      }
      return {
        data: transformUpdateData({
          originalData: state.data,
          updatedData: action.updatedItem,
        }),
      };
    case ActionType.UpdateStatus:
      if (!action.updatedStatusItem) {
        throw new Error("Updated item does not exists");
      }
      return {
        data: transformUpdateStatusData({
          originalData: state.data,
          updatedData: action.updatedStatusItem,
        }),
      };
    case ActionType.Delete:
      if (!action.deletedId) {
        throw new Error("Deleted id does not exist");
      }
      return {
        data: transformDeleteData({
          originalData: state.data,
          deletedId: action.deletedId,
        }),
      };
    default:
      return state;
  }
};
